import { setShowCaveatModal } from '../State/showCaveatModal';
import { setSelectedCaveatId } from '../State/selectedCaveatId';

export default () => async (dispatch) => {

  dispatch(setShowCaveatModal(false));
  dispatch(setSelectedCaveatId(null));

}